/* global.js — interactions globales du thème Chérie Charms
   Vanilla JS, zéro dépendance. Chargé en defer. */
(function () {
  'use strict';

  var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ---- Utilitaire : ouvrir/fermer un panneau (drawer/nav/overlay) ------- */
  function setOpen(el, open) {
    if (!el) return;
    el.setAttribute('aria-hidden', open ? 'false' : 'true');
  }

  /* ---- Menu hamburger ---------------------------------------------------- */
  var navToggle = document.querySelector('[data-nav-toggle]');
  var navDrawer = document.querySelector('[data-nav-drawer]');
  var overlay = document.querySelector('[data-overlay]');

  function closeAll() {
    setOpen(navDrawer, false);
    document.querySelectorAll('[data-cart-drawer]').forEach(function (d) { setOpen(d, false); });
    if (overlay) setOpen(overlay, false);
    document.body.style.overflow = '';
    if (navToggle) navToggle.setAttribute('aria-expanded', 'false');
  }
  window.CherieCloseAll = closeAll;

  if (navToggle && navDrawer) {
    navToggle.addEventListener('click', function () {
      var isOpen = navDrawer.getAttribute('aria-hidden') === 'false';
      if (isOpen) { closeAll(); return; }
      setOpen(navDrawer, true);
      setOpen(overlay, true);
      navToggle.setAttribute('aria-expanded', 'true');
      document.body.style.overflow = 'hidden';
    });
  }
  if (overlay) overlay.addEventListener('click', closeAll);
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeAll(); });
  document.querySelectorAll('[data-close-drawer]').forEach(function (btn) {
    btn.addEventListener('click', closeAll);
  });

  /* ---- Fil de perles : apparition au scroll (IntersectionObserver) ------ */
  var dividers = document.querySelectorAll('.bead-divider');
  if (dividers.length) {
    if (reduceMotion || !('IntersectionObserver' in window)) {
      dividers.forEach(function (d) { d.classList.add('is-visible'); });
    } else {
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add('is-visible');
            io.unobserve(entry.target);
          }
        });
      }, { threshold: 0.4 });
      dividers.forEach(function (d) { io.observe(d); });
    }
  }

  /* ---- CTA sticky mobile sur la page produit ---------------------------- */
  var stickyAtc = document.querySelector('[data-sticky-atc]');
  var primaryAtc = document.querySelector('[data-primary-atc]');
  if (stickyAtc && primaryAtc && 'IntersectionObserver' in window) {
    var stickyObserver = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        // affiche le CTA sticky dès que le vrai bouton n'est pas visible (au-dessus comme en dessous),
        // et le masque quand le vrai bouton apparaît à l'écran
        stickyAtc.classList.toggle('is-visible', !entry.isIntersecting);
      });
    }, { threshold: 0 });
    stickyObserver.observe(primaryAtc);
  }

  /* ---- Estimation de livraison (bloc d'achat) --------------------------- */
  var deliveryEl = document.querySelector('[data-delivery-estimate]');
  if (deliveryEl) {
    var minD = parseInt(deliveryEl.getAttribute('data-min'), 10) || 7;
    var maxD = parseInt(deliveryEl.getAttribute('data-max'), 10) || 14;
    var addBusinessDays = function (n) {
      var d = new Date(), added = 0;
      while (added < n) {
        d.setDate(d.getDate() + 1);
        var day = d.getDay();
        if (day !== 0 && day !== 6) added++;
      }
      return d;
    };
    try {
      var fmt = new Intl.DateTimeFormat('fr-FR', { day: 'numeric', month: 'long' });
      deliveryEl.textContent = 'livré entre le ' + fmt.format(addBusinessDays(minD)) + ' et le ' + fmt.format(addBusinessDays(maxD));
    } catch (e) {}
  }

  /* ---- Galerie produit : gérée par product-gallery.js (dominante + vignettes + lightbox) ---- */

  /* ---- Onglets de description ------------------------------------------- */
  document.querySelectorAll('[data-tabs]').forEach(function (tabs) {
    var btns = tabs.querySelectorAll('[data-tab-btn]');
    var panels = tabs.querySelectorAll('[data-tab-panel]');
    btns.forEach(function (btn, i) {
      btn.addEventListener('click', function () {
        btns.forEach(function (b) { b.setAttribute('aria-selected', 'false'); });
        panels.forEach(function (p) { p.hidden = true; });
        btn.setAttribute('aria-selected', 'true');
        if (panels[i]) panels[i].hidden = false;
      });
    });
  });

  /* ---- Compte à rebours (announcement bar + urgence) -------------------- */
  document.querySelectorAll('[data-countdown]').forEach(function (el) {
    var deadline = new Date(el.getAttribute('data-countdown')).getTime();
    if (isNaN(deadline)) return;
    function tick() {
      var diff = deadline - Date.now();
      if (diff <= 0) { el.textContent = el.getAttribute('data-expired') || '00:00:00'; return; }
      var d = Math.floor(diff / 86400000);
      var h = Math.floor((diff % 86400000) / 3600000);
      var m = Math.floor((diff % 3600000) / 60000);
      var s = Math.floor((diff % 60000) / 1000);
      function pad(n) { return String(n).padStart(2, '0'); }
      el.textContent = (d > 0 ? d + 'j ' : '') + pad(h) + ':' + pad(m) + ':' + pad(s);
      setTimeout(tick, 1000);
    }
    tick();
  });
})();
